import { images } from './images';
import ImageWrapper from '../components/ImageWrapper';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { useState } from 'react';
import { Fullscreen, Zoom } from 'yet-another-react-lightbox/plugins';

export default function SocialGatheringsGallery() {
    const [open, setOpen] = useState(false);
    const [lightboxIndex, setIndex] = useState();

    return (
        <div className="page__width flex justify-center flex-col gap-4">
            <h2 className="text-3xl lg:text-5xl text-white text-center">
            Social Gatherings
            </h2>
            <div className="masonry page__width my-8">
                {images['Social Gatherings'].images.map((img, index) => {
                    return (
                        <ImageWrapper
                            className={`masonry_item ${img.dimensions}`}
                            key={index}
                            src={img.src}
                            onClick={() => {
                                setIndex(index);
                                setOpen(true);
                            }}
                        />
                    );
                })}
                <Lightbox
                    open={open}
                    index={lightboxIndex}
                    close={() => setOpen(false)}
                    slides={images['Social Gatherings'].images}
                    plugins={[Fullscreen, Zoom]}
                />
            </div>
        </div>
    );
}
